import { FC, ReactNode } from 'react';

import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Caret } from '@zazume/zzm-base';

const ModalWrapper = styled.div(
  ({ theme }) => css`
    position: relative;
  `
);

const DesktopNavigationButton = styled.button(
  ({ theme }) => css`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    display: none;
    align-items: center;
    justify-content: center;
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    background-color: ${theme.colors.White};
    border: 1px solid ${theme.colors.Gray300};
    cursor: pointer;
    z-index: 1000;
    transition: all 0.2s ease;

    ${theme.mq.desktop} {
      display: flex;
    }

    &:hover {
      background-color: ${theme.colors.Gray200};
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    &:focus {
      outline: none;
      box-shadow: 0 0 0 2px ${theme.colors.Primary}40;
    }
  `
);

const PreviousDesktopButton = styled(DesktopNavigationButton)`
  left: -5.5rem;
`;

const NextDesktopButton = styled(DesktopNavigationButton)`
  right: -5.5rem;
`;

interface DesktopNavigationButtonsProps {
  documentId: string;
  onNextClick?: (id: string) => void;
  onPreviousClick?: (id: string) => void;
  hasNext?: boolean;
  hasPrevious?: boolean;
  children: ReactNode;
}

export const DesktopNavigationButtons: FC<DesktopNavigationButtonsProps> = ({
  onNextClick,
  onPreviousClick,
  hasNext,
  hasPrevious,
  documentId,
  children
}) => {
  const showNavigation = Boolean(onNextClick || onPreviousClick);
  const canGoNext = hasNext !== undefined ? hasNext : Boolean(onNextClick);
  const canGoPrevious = hasPrevious !== undefined ? hasPrevious : Boolean(onPreviousClick);

  return (
    <ModalWrapper>
      {showNavigation && onPreviousClick && (
        <PreviousDesktopButton onClick={() => onPreviousClick(documentId)} type="button" disabled={!canGoPrevious}>
          <Caret direction="left" size={24} color="Gray600" />
        </PreviousDesktopButton>
      )}
      {children}
      {showNavigation && onNextClick && (
        <NextDesktopButton onClick={() => onNextClick(documentId)} type="button" disabled={!canGoNext}>
          <Caret direction="right" size={24} color="Gray600" />
        </NextDesktopButton>
      )}
    </ModalWrapper>
  );
};
